import { types } from "../types/typesNotificaciones";

const initialState = {
  notificaciones: [],
  activeNotificacion: null,
  loading: false,
};
export const notificacionReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.notificacionesLoaded:
      return { ...state, notificaciones: action.payload };
    case types.notificacionAdded:
      return {
        ...state,
        notificaciones: [action.payload, ...state.notificaciones],
      };
    case types.notificacionSetActive:
      return {
        ...state,
        activeNotificacion: action.payload,
      };
    case types.notificacionClearActive:
      return {
        ...state,
        activeNotificacion: null,
      };
    case types.notificacionUpdated:
      return {
        ...state,
        notificaciones: state.notificaciones.map((e) =>
          e.id === action.payload.id ? action.payload : e,
        ),
      };
    case types.notificacionDeleted:
      return {
        ...state,
        notificaciones: state.notificaciones.filter(
          (e) => e.id !== action.payload.id,
        ),
        activeNotificacion: null,
      };
    case types.notificacionLoading:
      return {
        ...state,
        loading: action.payload,
      };
    case types.notificacionLogout:
      return { ...initialState };
    default:
      return state;
  }
};
